<template>
  <div class="app flex-row align-items-center">
    <DebugWindow v-if="showDebug"></DebugWindow>
    <div class="logo-container">
      <img :src="iris" style="width: 75%; z-index: 2">
    </div>
    <div class="login-container">
      <div class="login-wrapper">
        <span class="welcome-text">WELCOME TO IRIS</span>
        <div class="form-wrapper">
          <div v-if="resetToken" class="input-wrapper">
            <input
                v-model="password1"
                placeholder="New password"
                class="form-control form-input"
                type="password"/>
            <input
                v-model="password2"
                placeholder="Repeat password"
                class="form-control form-input"
                type="password"/>
          </div>
          <div v-else class="input-wrapper">
            <input
                v-model="email"
                placeholder="Email address"
                class="form-control form-input"
                type="text"/>
          </div>
          <button @click="resetToken ? changePassword() : sendResetEmail()" class="btn px-4 btn-primary">
            Reset Password
          </button>
          <button @click="goToLogin" class="btn px-4 btn-primary back-button">
            Back
          </button>
          <div class="error-box">
            {{error}}
          </div>
        </div>
      </div>
      <div class="symrise-logo">
        <a href="https://www.symrise.com/" target="_blank">
          <img :src="logo"/>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import DebugWindow from '../components/shared/DebugWindow'
import userActions from '../store/modules/users/actionTypes'
import logo from '../assets/images/logos/symrise-logo.svg'
import iris from '../assets/images/logos/Iris_Logo_Light_Grey_Shadow.svg'

export default {
  components: {
    DebugWindow
  },
  data () {
    return {
      email: '',
      error: null,
      resetToken: '',
      resetRequested: false,
      password1: '',
      password2: '',
      showAlert: false,
      showDebug: false,
      logo,
      iris
    }
  },
  methods: {
    ...mapActions({
      sendPasswordReset: userActions.SEND_PASSWORD_RESET
    }),
    changePassword () {
      if (this.password1 !== this.password2) {
        this.error = 'Passwords does not match'
        return
      }
      this.axios.post('/auth/reset-password/', {
        new_password: this.password1,
        token: this.resetToken
      }).then((response) => {
        if (response.status === 200) {
          this.$router.push('/login')
        }
      }).catch((response) => this.error = response.data)
    },
    goToLogin () {
      this.$router.push('/login')
    },
    async sendResetEmail () {
      let clientAddress = window.location.href.split(this.$route.path)[0]
      clientAddress = clientAddress.replace('http://', '')
      clientAddress = clientAddress.replace('https://', '')
      const response = await this.sendPasswordReset({
        email: this.email,
        client_address: clientAddress
      })
      if (response.status === 200) {
        this.resetRequested = true
        this.error = 'A message with the password reset link was sent to the provided e-mail address.'
      } else {
        this.error = response.data
      }
    }
  },
  mounted () {
    if (this.$route.params.token) {
      this.resetToken = this.$route.params.token
    }
    if (this.$route.query.expired) {
      this.error = 'You have not logged in for 30 days. You must change your password for security reasons.'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables";

.logo-container {
  height: 100vh;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/images/backgrounds/login.jpg");
  background-position: center;
  background-size: cover;
  overflow: hidden;

  h1 {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 900;
    font-size: 250px;
    color: $white;
  }
}

.login-container {
  height: 100vh;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $white;

  .symrise-logo {
    position: fixed;
    bottom: 47px;
    right: 43.5px;
  }

  .login-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 568px;
    height: 537px;

    .welcome-text {
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 900;
      font-size: 72px;
      line-height: 103px;
      color: $soot;
      letter-spacing: 0;
      white-space: nowrap;
    }

    .form-wrapper {
      width: 400px;

      .input-wrapper {
        height: 115px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .form-input {
          border: none;
          border-bottom: 2px solid $pewter;
        }
      }

      .form-actions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 60px;
        margin-top: 30px;

        .link {
          font-family: 'Source Sans Pro', sans-serif;
          font-weight: 400;
          font-size: 14px;
          line-height: 25px;
          transition: color 0.1s linear;
          color: $grey-800;
          text-decoration: none;

          &:hover {
            color: $grey-700;
          }
        }
      }

      button {
        background: $blueberry 0 0 no-repeat padding-box;
        border: 1px solid #17469E;
        border-radius: 6px;
        width: 100%;
        height: 50px;
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 900;
        font-size: 20px;
        line-height: 26px;
        color: $white;
        letter-spacing: 0;

        &:hover {
          background-color: #9256D9;
        }
      }

      .back-button {
        margin-top: 20px;
        background: $pewter;
        border-radius: 6px;
        border: 0;

        &:hover {
          background-color: $charcoal;
        }
      }

      .error-box {
        margin-top: 10px;
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $red-600;
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>
